import { CartLine } from '@portal/api/shopifyV2/types';

// Key for separating cart subscription section with disabled cadence (e.g bundles)
export const NO_CADENCE_KEY = 'no-cadence';

export const isWelcomeKitOtp = (item: CartLine) =>
  item.attributes?.find((attr) => attr.key === '__custom.otp_welcome_kit')?.value === 'true';

export const isWelcomeKitSub = (item: CartLine) =>
  item.attributes?.find((attr) => attr.key === '__custom.welcome_kit')?.value === 'true';

export const isWelcomeKit = (item: CartLine) => isWelcomeKitOtp(item) || isWelcomeKitSub(item);

export const calculateFinalPrice = (item: CartLine) => {
  const finalPrice = parseFloat(item.cost.totalAmount.amount || '0');
  const originalTotalPrice = parseFloat(item.cost.subtotalAmount.amount || '0');

  const hasDiscounts = originalTotalPrice > finalPrice;

  return { originalTotalPrice, hasDiscounts, finalPrice };
};
